import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';

import { Button, Flex, P, Table } from '@decisiv/ui-components';
import InfoCircle from '@decisiv/iconix/lib/components/InfoCircle';

import CommandErrorDetailModal from './detailModal';
import { TableWrapper } from './style';

// The catalog templates carry a Ruby format token; render it as a readable placeholder.
const humanizeTemplate = (template) =>
  template ? template.replace(/%<provider>s/g, '<Provider>') : '—';

export default function CommandErrorsTable({ commandErrors, totalRecords }) {
  const [selectedError, setSelectedError] = useState(null);

  const columns = [
    {
      DataCell: (data) => {
        const { error_type: errorType, kind } = data?.rowData?.attributes || {};

        return (
          <span>
            {errorType}
            {kind === 'outcome' && ` (${t`outcome`})`}
          </span>
        );
      },
      title: t`TYPE`,
      name: 'error_type',
    },
    {
      DataCell: (data) => <span>{data?.rowData?.attributes?.title}</span>,
      title: t`TITLE`,
      name: 'title',
    },
    {
      DataCell: (data) => (
        <span>
          {humanizeTemplate(data?.rowData?.attributes?.detail_template)}
        </span>
      ),
      title: t`USER MESSAGE`,
      name: 'detail_template',
    },
    {
      DataCell: (data) => (
        <Button
          icon={InfoCircle}
          variant="ghost"
          size="small"
          aria-label={t`Details`}
          onClick={() => setSelectedError(data?.rowData)}
        />
      ),
      title: t`DETAILS`,
      name: 'details',
    },
  ];

  return (
    <TableWrapper>
      <Table
        columns={columns}
        data={commandErrors}
        kind="secondary"
        getRowKey={({ id }) => id}
        footer={() => (
          <Flex flex={1} alignItems="center" justifyContent="flex-start">
            <P>{totalRecords} Items</P>
          </Flex>
        )}
      />
      {selectedError && (
        <CommandErrorDetailModal
          commandError={selectedError}
          onClose={() => setSelectedError(null)}
        />
      )}
    </TableWrapper>
  );
}

CommandErrorsTable.propTypes = {
  commandErrors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      attributes: PropTypes.shape({
        error_type: PropTypes.string,
        kind: PropTypes.string,
        code: PropTypes.string,
        class_name: PropTypes.string,
        title: PropTypes.string,
        detail_template: PropTypes.string,
        default_status: PropTypes.number,
        statuses: PropTypes.arrayOf(PropTypes.number),
        retryable: PropTypes.bool,
        notifies_support: PropTypes.bool,
        description: PropTypes.string,
      }),
    }),
  ).isRequired,
  totalRecords: PropTypes.number.isRequired,
};
